import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SessionService } from '../../Services/session.service';
import { EncryptionDecryptionService } from '../../Services/encryption-decryption/encryption-decryption.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { DashboardService } from '../../Services/Dashboard/dashboard.service';
import { RequirementStatus, DashBoardFilterModel, DashBoardDetails } from '../../Models/Dashboard/DashboardFilters';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { PagerService } from '../../Services/pager.service';
import { DropDownRequest, DropDownResponse, QuarterTypeModel, RequirmentTypeModel, WHLocationModel } from '../../Models/DropDwon/DropDownRequest';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { ToastrService } from 'ngx-toastr';
import { SBUModel } from '../../Models/DropDwon/SBUModel';
import { DivisionModel } from '../../Models/DropDwon/DvisionModel';
import { ZoneModel } from '../../Models/DropDwon/ZoneModel';
import { RegionModel, RMHModel } from '../../Models/DropDwon/RegionModel';
import { productModel } from '../../Models/DropDwon/ProductModel';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { ChangeDetectorRef } from '@angular/core';
import { $$ } from 'protractor';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [PagerService, DatePipe]
})
export class HomeComponent implements OnInit {

  public ddlRequest: DropDownRequest = new DropDownRequest();
  public ddlResponse: DropDownResponse = new DropDownResponse();
  public SBUSettings = {};
  public SBUSelectedItem: SBUModel[];

  public DivisionSettings = {};
  public DivisionSelectedItem: DivisionModel[];

  public ZoneSettings = {};
  public ZoneSelectedItem: ZoneModel[];

  public RegionSettings = {};
  public RegionselectedItems: RegionModel[];

  public YearSettings={};
  public YearselectedItems:YearModel[];

  public RMHSettings = {};
  public RMHSelectedItems: RMHModel[];
  public ProductSettings = {};
  public CropSettings={};
  public ProductSelectedItem: productModel[];
  public FlagDropDown: string;
  loader = 'none';
  userId: string;
  roleId: string;
  userName: string;
  @ViewChild('requirmentType') requirmentType;
  @ViewChild('quarterType') quarterType;
  @ViewChild('regionSelect') regionSelect;
  @ViewChild('sbu') sbu;
  @ViewChild('division') division;
  @ViewChild('zone') zone;
  @ViewChild('rmh') rmh;
  @ViewChild('productSelect') productSelect;
  @ViewChild('year') year;
  @ViewChild('month') month;
  @ViewChild('status') status;
  @ViewChild('warehouseLocation') warehouseLocation;
  @ViewChild('yearSelect') yearSelect;
  @ViewChild('cropSelect') cropSelect;

  public RequirmentTypeSettings = {};
  public requirmentTypeDdl: RequirmentTypeModel[];

  public requirmentDllValue: any;

  public QuarterTypeSettings = {};
  public quarterTypeDdl: QuarterTypeModel[];
  public quarterDllValue: any;
  
  selectedSbu: any[] = [];
  selectedDivision: any[] = [];
  selectedZone: any[] = [];
  selectedRegion: any[] = [];
  selectedRMH: any[] = [];
  selectedProduct: any[] = [];
  selectedMonth: any[] = [];
  selectedStatus: any[] = [];
  selectedYear: any[]=[];
  selecteedcrop:any[]=[];
  commaSeperatedCrop:string;
  commaSeperatedSbus: string;
  commaSeperatedDivisions: string;
  commaSeperatedZones: string;
  commaSeperatedRegions: string;
  commaSeperatedRMH: string;
  commaSeperatedProduct: string;
  commaSeperatedMonth: string;
  commaSeperatedStatus: string;
  commaSeperatedReqType: string;
  commaSeperatedQuartType: string;
  commaSeperatedYear:string;
  public monthList: any;
  public currentYear: any;
  public currentYearPlus: any;
  public Month: any;
  public statusList: any;
  public Status: any;
  public dropdownMonthSettings: {};
  public dropdownStatusSettings: {};
  statusModel: RequirementStatus[] = [];
  dashBoardDetails: DashBoardDetails[] = [];
  selectedReqType: any[] = [];
  selectedReqTypeModel: any[] = [];
  selectedQuartType: any[] = [];
  selectedQuartTypeModel: any[] = [];
  selectedYearType:any[]=[];
  defaultValue = 'none';
  msgView: boolean = false;
  public dashBoardRequestModel: DashBoardFilterModel = new DashBoardFilterModel();
  public WarehouseLocationSettings = {};
  public WarehouseLocationSelectedItem: WHLocationModel[];


  constructor(private session: SessionService, private ddlServices: DropDownService, private toastr: ToastrService, private dashBoardService: DashboardService, private cd: ChangeDetectorRef) {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId = localStorage.getItem('dsu_roleId');
    this.userName = localStorage.getItem('dsu_userName');
    this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44" || this.roleId == "77") ? "DEFAULT" : "DEFAULT";

  }

  ngOnInit(): void {
   
    clearInterval(this.session.id);
    this.session.startSession();
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.currentYear = new Date();
    this.currentYearPlus = this.currentYear.getFullYear();
    // this.Month = this.currentYear.getMonth();
    this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        
        if (response.status) {
         
          this.ddlResponse = response.data;
          this.GetWarehouseLocationData();
          this.ddlResponse.year=response.data.year;
          class YearItemList{
              id: any;
              text: any;
          }
            let requiredItem: YearItemList[] = [];
            var obj = {
              id : (new Date()).getFullYear(),
              text: (new Date()).getFullYear()
            }
            requiredItem.push(obj)
            this.year.selectedItems = requiredItem
            // for(var i=0;i<this.year.selectedItems.length; i++){
            //     this.yearSelect.push(this.year.selectedItems[i].text)
            // }
          this.YearSetting();
      }
        
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
      });
    // this.requirmentTypeDdl = [{ id: 1, text: "Annual" }, { id: 2, text: "Additional" }];
    if(this.roleId == '56'){
      this.requirmentTypeDdl = [{ id: 3, text: "Additional" }];
    }else{
      this.requirmentTypeDdl = [{ id: 1, text: "H1" }, { id: 2, text: "H2" }, { id: 3, text: "Additional" }];
    }
    this.RequirmentTypeSetting();
    this.SBUMHSetting();
    this.DivisionSetting();
    this.ZoneSetting();
    this.RegionSetting();
    this.RMHSetting();
    this.ProductSetting();
    this.CropSetting();
    this.getMonthList();
    this.getStatus();
    this.YearSetting();
    this.WareHouseLocationSetting();
    this.QuarterTypeSetting();
  
    if(this.requirmentTypeDdl.length >=2)
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];
    }
    else if(this.requirmentTypeDdl[0].text == 'Additional')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];

    }
    else if(this.requirmentTypeDdl[0].text == 'H1')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" }];


    }
    else if(this.requirmentTypeDdl[0].text == 'H2')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q3" }, { id: 2, text: "Q4" }];
    }
    else{
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];

    }
  

    for (var i = 0; i < this.requirmentTypeDdl.length; i++) {
      this.requirmentType.selectedItems.push(this.requirmentTypeDdl[i]);
    }
    this.onReqTypeSelectAll(this.requirmentType);
    
    // for (var i = 0; i < this.quarterTypeDdl.length; i++) {
    //   this.quarterType.selectedItems.push(this.quarterTypeDdl[i]);
    // }
    this.getDashBoardDetails();
  }
  ConvertToCurrency(value:any)
  {
        var parts = value.toString().replace(',','').split(".");
        if(parts[0].length > 3){
        parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
        }
        return parts.join(".");
  }
  WareHouseLocationSetting() {
    this.WarehouseLocationSettings = {
      singleSelection: false,
      idField: 'whId',
      textField: 'whName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Warehouse Location Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RequirmentTypeSetting() {
    this.RequirmentTypeSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Requirment Type Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  YearSetting() {
    this.YearSettings = {
      singleSelection: false,
      idField: 'year',
      textField: 'year',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RequirementYear Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  
  QuarterTypeSetting() {
    this.QuarterTypeSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Quarter Type Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  
  SBUMHSetting() {
    this.SBUSettings = {
      singleSelection: false,
      idField: 'sbuCode',
      textField: 'sbuName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No SBU Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  DivisionSetting() {
    this.DivisionSettings = {
      singleSelection: false,
      idField: 'divisionCode',
      textField: 'divisionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Division Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  ZoneSetting() {
    this.ZoneSettings = {
      singleSelection: false,
      idField: 'zoneCode',
      textField: 'zoneName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Zone Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  RegionSetting() {
    this.RegionSettings = {
      singleSelection: false,
      idField: 'regionCode',
      textField: 'regionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      //maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Region Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  RMHSetting() {
    this.RMHSettings = {
      singleSelection: false,
      idField: 'rmhCode',
      textField: 'rmhName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  ProductSetting() {
    this.ProductSettings = {
      singleSelection: false,
      idField: 'productId',
      textField: 'productName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Product Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  CropSetting() {
    this.CropSettings = {
      singleSelection: false,
      idField: 'cropId',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Product Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  getMonthList(): void {
    type MyArrayType = Array<{ Id: number, Text: string }>;
    this.bindMonthDropdownSetting();
    const arr: MyArrayType = [
      { Id: 1, Text: 'Jan' },
      { Id: 2, Text: 'Feb' },
      { Id: 3, Text: 'Mar' },
      { Id: 4, Text: 'Apr' },
      { Id: 5, Text: 'May' },
      { Id: 6, Text: 'Jun' },
      { Id: 7, Text: 'Jul' },
      { Id: 8, Text: 'Aug' },
      { Id: 9, Text: 'Sep' },
      { Id: 10, Text: 'Oct' },
      { Id: 11, Text: 'Nov' },
      { Id: 12, Text: 'Dec' },
    ];
    this.monthList = arr;
    this.month = arr;
    //this.monthList.filter((item) => item.Id === (this.Month));

  }

  bindMonthDropdownSetting() {
    this.dropdownMonthSettings = {
      singleSelection: false,
      text: "Select Month",
      idField: 'Id',
      textField: 'Text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'No Month Found'
    };
  }
  getStatus() {
    this.loader = 'block';
    this.bindStatusDropdownSetting();
    this.dashBoardService.getStatus(this.userId, this.roleId)
      .subscribe((resData) => {
        this.statusModel = resData.data;
        this.statusList = this.statusModel;
        this.Status = this.statusModel
        this.loader = 'none';

      });
  }
  bindStatusDropdownSetting() {
    this.dropdownStatusSettings = {
      singleSelection: false,
      text: "Select Status",
      idField: 'id',
      textField: 'status',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'No Status Found'
    };
  }
  public onSBUSelect(item: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ");
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelect(item: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ");

    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onSBUSelectAll(items: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ")
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelectAll(items: any) {
    this.selectedSbu = [];
    this.commaSeperatedSbus = '';
    this.GetSBUWiseData(this.sbu.selectedItems);
  }


  public onDivisionSelect(item: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ");

    this.GetDivisionWiseData(this.division.selectedItems);

  }
  public onDivisionDeSelect(item: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ")
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onDivisionSelectAll(items: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ")
    this.GetDivisionWiseData(this.division.selectedItems);
  }
  public onDivisionDeSelectAll(items: any) {
    this.selectedDivision = [];
    this.commaSeperatedDivisions = '';
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onZoneSelect(item: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onZoneDeSelect(item: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onZoneSelectAll(items: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onZoneDeSelectAll(items: any) {
    this.selectedZone = [];
    this.commaSeperatedZones = '';
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onRegionSelect(item: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    this.GetRegionWiseData(this.regionSelect.selectedItems);
  }
  public onRegionDeSelect(item: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    if (this.roleId != '42' && this.roleId!='56' && this.roleId!='76') {
      this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
  }

  public onRegionSelectAll(items: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    if (this.roleId != '42' && this.roleId!='56' && this.roleId!='76') {
      this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
  }
  public onRegionDeSelectAll(items: any) {
    this.selectedRegion = [];
    this.commaSeperatedRegions = '';
    if (this.roleId != '42' && this.roleId!='56' && this.roleId!='76') {
      this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
  }
  GetRegionWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          if ((this.roleId == '42' || this.roleId=='56' || this.roleId=='76') && response.data.rmh.length > 0) {
            this.ddlResponse.rmh = response.data.rmh;
          }

          else if (response.data.rmh.length > 0)
            this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
          else
            this.rmh.selectedItems = [];
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  public onRMHSelect(item: any) {
    this.selectedRMH = [];
    for (var i = 0; i < this.rmh.selectedItems.length; i++) {
      this.selectedRMH.push(this.rmh.selectedItems[i].id)
    }
    this.commaSeperatedRMH = this.selectedRMH.join(", ");
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
  }
  public onRMHDeSelect(item: any) {
    this.selectedRMH = [];
    for (var i = 0; i < this.rmh.selectedItems.length; i++) {
      this.selectedRMH.push(this.rmh.selectedItems[i].id)
    }
    this.commaSeperatedRMH = this.selectedRMH.join(", ");
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
  }

  public onRMHSelectAll(items: any) {
    this.selectedRMH = [];
    for (var i = 0; i < this.rmh.selectedItems.length; i++) {
      this.selectedRMH.push(this.rmh.selectedItems[i].id)
    }
    this.commaSeperatedRMH = this.selectedRMH.join(", ");
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
  }
  public onRMHDeSelectAll(items: any) {
    this.selectedRMH = [];
    this.commaSeperatedRMH = '';
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
  }
  onReqTypeSelect(item: any) {
    
    if(this.requirmentType.selectedItems.length >=2)
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];

    }
    
    
    else  if(item.text =='H1')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" }];

    }
    else if (item.text =='H2')
    {
      
      this.quarterTypeDdl = [{ id: 1, text: "Q3" }, { id: 2, text: "Q4" }];
    }
    else if(item.text== 'Additional')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];

    }
    else{
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];

    }
    this.selectedReqType = [];
    for (var i = 0; i < this.requirmentType.selectedItems.length; i++) {
      this.selectedReqType.push(this.requirmentType.selectedItems[i].text)
    }
    this.commaSeperatedReqType = this.selectedReqType.join(", ");
    //this.RequirmentTypeSetting();
  }
  onReqTypeDeSelect(item: any) {
   
    if(this.requirmentType.selectedItems.length == 0)
    {
      this.quarterTypeDdl = [];
    }
    else if(this.requirmentType.selectedItems.length >=2)
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];

    }
    else if(this.requirmentType.selectedItems[0].text == 'Additional')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" },{ id: 3, text: "Q3" }, { id: 4, text: "Q4" }];
    }
    else if(this.requirmentType.selectedItems[0].text == 'H1')
    {
      this.quarterTypeDdl = [{ id: 1, text: "Q1" }, { id: 2, text: "Q2" }];

    }
    else if(this.requirmentType.selectedItems[0].text == 'H2')
    {

      this.quarterTypeDdl = [{ id: 1, text: "Q3" }, { id: 2, text: "Q4" }];
    }
    this.selectedReqType = [];
    for (var i = 0; i < this.requirmentType.selectedItems.length; i++) {
      this.selectedReqType.push(this.requirmentType.selectedItems[i].text)
    }
    this.commaSeperatedReqType = this.selectedReqType.join(", ");
  }
  public onReqTypeSelectAll(items: any) {
    this.selectedReqType = [];
    for (var i = 0; i < this.requirmentType.selectedItems.length; i++) {
        this.selectedReqType.push(this.requirmentType.selectedItems[i].text)
      }
    this.commaSeperatedReqType = this.selectedReqType.join(", ");
    //this.RequirmentTypeSetting();
  }

  public onReqTypeDeSelectAll(items: any) {
    this.selectedReqType = [];
    this.commaSeperatedReqType = '';
  }

  onQuartTypeSelect(item:any){

    this.selectedQuartType = [];
    for (var i = 0; i < this.quarterType.selectedItems.length; i++) {
      this.selectedQuartType.push(this.quarterType.selectedItems[i].text)
    }
    this.commaSeperatedQuartType = this.selectedQuartType.join(", ");
  }
  onQuartTypeDeSelect(item: any) {
    this.selectedQuartType = [];
    for (var i = 0; i < this.quarterType.selectedItems.length; i++) {
      this.selectedQuartType.push(this.quarterType.selectedItems[i].text)
    }
    this.commaSeperatedQuartType = this.selectedQuartType.join(", ");
  }
  public onQuartTypeSelectAll(items: any) {
    
    this.selectedQuartType = [];
    for (var i = 0; i < this.quarterType.selectedItems.length; i++) {
        this.selectedQuartType.push(this.quarterType.selectedItems[i].text)
      }
    this.commaSeperatedQuartType = this.selectedQuartType.join(", ");
    //this.RequirmentTypeSetting();
  }
  public onQuartTypeDeSelectAll(items: any) {
    this.selectedQuartType = [];
    this.commaSeperatedQuartType = '';
  }
  
  onYearSelect(item:any){
    this.selectedYearType = [];
    for (var i = 0; i < this.year.selectedItems.length; i++) {
      this.selectedYearType.push(this.year.selectedItems[i].text)
    }
    this.commaSeperatedYear = this.selectedYearType.join(", ");
  }
  onYearDeSelect(item: any) {
    this.selectedYearType = [];
    for (var i = 0; i < this.year.selectedItems.length; i++) {
      this.selectedYearType.push(this.year.selectedItems[i].text)
    }
    this.commaSeperatedYear = this.selectedQuartType.join(", ");
  }
  public onYearSelectAll(items: any) {
    this.selectedYearType = [];
    for (var i = 0; i < this.year.selectedItems.length; i++) {
        this.selectedYearType.push(this.year.selectedItems[i].text)
      }
    this.commaSeperatedYear = this.selectedYearType.join(", ");
    //this.RequirmentTypeSetting();
  }
  public onYearDeSelectAll(items: any) {
    this.selectedYearType = [];
    this.commaSeperatedYear = '';
  }
  public onProductSelect(item: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].id)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }
  public onProductDeSelect(item: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].text)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }

  public onProductSelectAll(items: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].id)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }
  public onProductDeSelectAll(items: any) {
    this.selectedProduct = [];
    this.commaSeperatedProduct = '';
  }

  public onMonthSelect(item: any) {
    this.selectedMonth.push(item.Id)
    this.commaSeperatedMonth = this.selectedMonth.join(", ");
  }
  public onMonthDeSelect(item: any) {
    this.selectedMonth.push(item.Id)
    this.commaSeperatedMonth = this.selectedMonth.join(", ");
  }

  public onMonthSelectAll(items: any) {
    this.selectedMonth.push(items.Id)
    this.commaSeperatedMonth = this.selectedMonth.join(", ");
  }
  public onMonthDeSelectAll(items: any) {
    this.selectedMonth = [];
    this.commaSeperatedMonth = '';

  }

  public onStatusSelect(item: any) {
    this.selectedStatus = [];
    for (var i = 0; i < this.status.selectedItems.length; i++) {
      this.selectedStatus.push(this.status.selectedItems[i].text)
    }
    this.commaSeperatedStatus = this.selectedStatus.join(", ");
  }
  public onStatusDeSelect(item: any) {
    this.selectedStatus = [];
    for (var i = 0; i < this.status.selectedItems.length; i++) {
      this.selectedStatus.push(this.status.selectedItems[i].text)
    }
    this.commaSeperatedStatus = this.selectedStatus.join(", ");
  }

  public onStatusSelectAll(items: any) {
    this.selectedStatus = [];
    for (var i = 0; i < this.status.selectedItems.length; i++) {
      this.selectedStatus.push(this.status.selectedItems[i].text)
    }
    this.commaSeperatedStatus = this.selectedStatus.join(", ");
  }
  public onStatusDeSelectAll(items: any) {
    this.selectedStatus = [];
    this.commaSeperatedStatus = '';
  }

  GetSBUWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.division = response.data.division;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.rmh = response.data.rmh;

          this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });

        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
      });
  }

  GetDivisionWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.rmh = response.data.rmh;

          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
      });
  }

  GetZoneWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.rmh = response.data.rmh;

          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
      });
  }

  GetRMHWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRMHWiseRegionDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          if (response.data.region.length > 0)
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
      else
          this.regionSelect.selectedItems = [];
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }

  getDashBoardDetails() {
  
    this.selecteedcrop=[];

    if(this.cropSelect != undefined)
    {
for (var i = 0; i < this.cropSelect.selectedItems.length; i++) {
      this.selecteedcrop.push(this.cropSelect.selectedItems[i].id)
    }
    this. commaSeperatedCrop = this.selecteedcrop.join(", ");
  }

    if (typeof (this.commaSeperatedReqType) == "undefined" || this.commaSeperatedReqType == '') {
      this.toastr.error('Please select requirement type.');
      this.loader = 'none';
      return false;
    }
    this.loader = 'block';
    if (this.commaSeperatedSbus == undefined) {
      this.commaSeperatedSbus = '';
    }
    if (this.commaSeperatedDivisions == undefined) {
      this.commaSeperatedDivisions = '';
    }
    if (this.commaSeperatedZones == undefined) {
      this.commaSeperatedZones = '';
    }
    if (this.commaSeperatedRegions == undefined) {
      this.commaSeperatedRegions = '';
    }
    if (this.commaSeperatedRMH == undefined) {
      this.commaSeperatedRMH = '';
    }
    if (this.commaSeperatedProduct == undefined) {
      this.commaSeperatedProduct = '';
    }
    if (this.commaSeperatedMonth == undefined) {
      this.commaSeperatedMonth = '';
    }
    if (this.commaSeperatedStatus == undefined) {
      this.commaSeperatedStatus = '';
    }
    if (this.commaSeperatedQuartType == undefined) {
      this.commaSeperatedQuartType = '';
    }
    if(this.commaSeperatedYear==undefined){
      this.commaSeperatedYear='';
    }
    if(this.commaSeperatedCrop == undefined)
    {

      this.commaSeperatedCrop="";
    }
    this.dashBoardRequestModel.UserId = this.userId;
    this.dashBoardRequestModel.RoleId = this.roleId;
    this.dashBoardRequestModel.ReqType = this.commaSeperatedReqType;
    this.dashBoardRequestModel.SBUCode = this.commaSeperatedSbus;
    this.dashBoardRequestModel.DivisionCode = this.commaSeperatedDivisions;
    this.dashBoardRequestModel.ZoneCode = this.commaSeperatedZones;
    this.dashBoardRequestModel.RegionCode = this.commaSeperatedRegions;
    this.dashBoardRequestModel.RMHCode = this.commaSeperatedRMH;
    this.dashBoardRequestModel.Product = this.commaSeperatedProduct;
    this.dashBoardRequestModel.Month = this.commaSeperatedMonth;
    this.dashBoardRequestModel.Status = this.commaSeperatedStatus;
    this.dashBoardRequestModel.Quarter=this.commaSeperatedQuartType;
    this.dashBoardRequestModel.Year=this.commaSeperatedYear;
    this.dashBoardRequestModel.Crop=this.commaSeperatedCrop;
    this.dashBoardRequestModel.Year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
  
    if (this.warehouseLocation.selectedItems.length > 0)
      this.dashBoardRequestModel.WhLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
    else
      this.dashBoardRequestModel.WhLocation = '';
      
    //this.dashBoardRequestModel.WhLocation = '';
    this.dashBoardService.getDashBoardDetails(this.dashBoardRequestModel)
      .subscribe((resData) => {
        this.defaultValue = 'block';
        this.dashBoardDetails = resData.data;
        console.log(resData.data);
        // if (this.dashBoardDetails == undefined || this.dashBoardDetails == null) {
        //   this.defaultValue = 'none';
        //   this.msgView = true;
        //   this.toastr.error('No record found.');
        //   this.loader = 'none';
        //   return false;
        // }

        this.loader = 'none';

      });
  }
  GetWarehouseLocationData() {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = 'TRUE';
    this.ddlServices.getWarehouseLocationDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.warehouseLocation = response.data.warehouse;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }

  downloadExcel() {
    let today = new Date();
    let month;
    if((today.getMonth() + 1)<10)
    {
      month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
      month = (today.getMonth() + 1).toString().slice(-2);
    }
    
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    if (typeof (this.commaSeperatedReqType) == "undefined" || this.commaSeperatedReqType == '') {
      this.toastr.error('Please select requirement type.');
      this.loader = 'none';
      return false;
    }
    this.loader = 'block';
    if (this.commaSeperatedSbus == undefined) {
      this.commaSeperatedSbus = '';
    }
    if (this.commaSeperatedDivisions == undefined) {
      this.commaSeperatedDivisions = '';
    }
    if (this.commaSeperatedZones == undefined) {
      this.commaSeperatedZones = '';
    }
    if (this.commaSeperatedRegions == undefined) {
      this.commaSeperatedRegions = '';
    }
    if (this.commaSeperatedRMH == undefined) {
      this.commaSeperatedRMH = '';
    }
    if (this.commaSeperatedProduct == undefined) {
      this.commaSeperatedProduct = '';
    }
    if (this.commaSeperatedMonth == undefined) {
      this.commaSeperatedMonth = '';
    }
    if (this.commaSeperatedStatus == undefined) {
      this.commaSeperatedStatus = '';
    }

    this.dashBoardRequestModel.UserId = this.userId;
    this.dashBoardRequestModel.RoleId = this.roleId;
    this.dashBoardRequestModel.ReqType = this.commaSeperatedReqType;
    this.dashBoardRequestModel.SBUCode = this.commaSeperatedSbus;
    this.dashBoardRequestModel.DivisionCode = this.commaSeperatedDivisions;
    this.dashBoardRequestModel.ZoneCode = this.commaSeperatedZones;
    this.dashBoardRequestModel.RegionCode = this.commaSeperatedRegions;
    this.dashBoardRequestModel.RMHCode = this.commaSeperatedRMH;
    this.dashBoardRequestModel.Product = this.commaSeperatedProduct;
    this.dashBoardRequestModel.Month = this.commaSeperatedMonth;
    this.dashBoardRequestModel.Status = this.commaSeperatedStatus;
    this.dashBoardService.downloadExcel(this.dashBoardRequestModel)
      .subscribe(
        success => {
          if (success.ok = true) {
            var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
            saveAs(blob, this.selectedReqType + "_" + this.userName + "_DashBoard_" + formattedDate + ".xlsx");
          }
          this.loader = 'none';
        },
        err => {
          this.toastr.error("No data found");
          //alert("No data found");
          //alert("Some problem occurred while downloading file.");
          this.loader = 'none';
        }
      );

  }

  getSDRMHWise(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getSDRMHWise(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.sd = response.data.sd;
          this.getWHRMHWise(this.ddlRequest.RMH, this.ddlResponse.sd)
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }

  getWHRMHWise(filter: any, filterSD: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = filter;
    this.ddlRequest.SD = Array.prototype.map.call(filterSD, function (item) { return item.sdCode; }).join(",");
    this.ddlServices.getWHRMHWise(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.warehouseLocation = response.data.warehouse;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  
  remarkContent: string = '';
  remarkDate: string = '';
  isPartiallyclosed: boolean;
  onImageClick(remark: any,status: any) {
  
    const closedContent = remark.split('!split!');
    this.remarkDate = closedContent[0];
    const processedRemark = closedContent[1].replace(/\\n/g, '\n');
    
    this.remarkContent = processedRemark.replace(/\n/g, '<br>');

    if(status.includes('Partially'))
    {
      this.isPartiallyclosed = true
    }
    else{
      this.isPartiallyclosed = false
    }
    this.cd.detectChanges();
  }
}
